module.exports = __webpack_public_path__ + "img/4f_r_twodays.b3139057.png";